import React, { FunctionComponent } from 'react';
import { isEditorActive } from '@sitecore-jss/sitecore-jss-react';
import Picture from '../picture';
import TextComponentDecider from '../TextComponentDecider';
import VideoPlayer from '../videoPlayer';
import { TGalleryCarouselItemProps } from './types/mediaCarousel.types';

const GalleryCarouselSlide: FunctionComponent<TGalleryCarouselItemProps> = ({ fields, RTDescription = false }) => {

  return (
    <div className={'slide__inner'}>
      {fields?.useVideo?.value ? (
        <VideoPlayer link={fields?.video?.value?.href} autoPlay={true} controls={false} loop={true} muted={true} playsInline={true} extraClassName={'slide__video-wrapper'} />
      ) : (
        <Picture
          editorialImageProps={
            fields?.editorialImageProps && {
              style: { zIndex: isEditorActive() ? 0 : -2 },
              cssClassImageEl: 'slide__image',
              ...fields?.editorialImageProps,
            }
          }
          productImageProps={
            fields?.productImageProps && {
              imageStyle: { zIndex: isEditorActive() ? 0 : -2 },
              imageClassName: 'slide__image',
              ...fields?.productImageProps,
            }
          }
        />
      )}
      <div className={'slide-footer'}>
        {fields?.description && (
          <TextComponentDecider
            type={RTDescription ? 'RichText' : 'Text'}
            field={fields?.description}
            tag="div"
            className={`slide-description ${RTDescription ? 'rich-text' : ''}`}
          />
        )}
      </div>
    </div>
  );
};

export default React.memo(GalleryCarouselSlide);
